import React from "react";
import PropTypes from "prop-types";
import ActionButton from "./action-button";

const AddAction = props => {
  return <ActionButton icon="add" {...props} />;
};

AddAction.propTypes = {
  /**
   * Indica si se muestra el componente
   **/
  show: PropTypes.bool,
  /**
   * Url del icono del menú
   **/
  url: PropTypes.string,
};

export default AddAction;
